import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { Styles } from "../styles/styles";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      
      <Switch>
        <Route
          path="/"
          exact
          component={lazy(() => import(`../pages/SignUp`))}
        />
        <Route
          path="/verify"
          exact
          component={lazy(() => import(`../pages/Verification`))}
        />
        <Route
          path="/wallet"
          exact
          component={lazy(() => import(`../pages/Wallet`))}
        />
      </Switch>
    </Suspense>
  );
};

export default Router;
